/*
 * The editor is a region *inside* the deal's card, so it is separated from the card's
 * read-only facts by a rule and a change of ground rather than by a border of its own. It
 * must not read as a second card floating in the first.
 */
.editor {
  display: grid;
  gap: var(--space-4);
  padding-block-start: var(--space-4);
  border-block-start: 1px solid var(--border);
}

.heading {
  font-family: var(--font-display);
  font-size: var(--text-lg);
}

/* Focus lands here when the editor opens; the ring is what tells a keyboard user they were
   moved, so it must be visible even though the heading is not otherwise interactive. */
.heading:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 4px;
  border-radius: var(--radius-sm);
}

.skeleton {
  display: grid;
  gap: var(--space-3);
}

.form {
  display: grid;
  gap: var(--space-5);
}

.intro {
  font-size: var(--text-sm);
  color: var(--text-muted);
  max-inline-size: var(--measure);
}

.fields {
  display: grid;
  gap: var(--space-4);
}

/*
 * The two prices are one fact read together — a before and an after — so they sit side by
 * side as soon as there is room, and stack on a phone rather than shrinking below a usable
 * target.
 */
.pair {
  display: grid;
  gap: var(--space-4);
}

@media (min-width: 40rem) {
  .pair {
    grid-template-columns: 1fr 1fr;
  }
}

/*
 * The consequence rail. It reuses the brass rule the deal card already uses for "what this
 * review state means", because this is the same kind of statement — what a state does to
 * the deal — rather than an error. Nothing here is red: nothing has gone wrong, and a
 * founder making a legitimate change must not be told off for it.
 */
.consequence {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-4);
  padding-inline-start: var(--space-4);
  border-inline-start: 3px solid var(--brass-rule);
  border-radius: var(--radius-sm);
  background: var(--brass-soft);
  color: var(--text);
  font-size: var(--text-sm);
  max-inline-size: var(--measure);
}

.consequenceTitle {
  font-weight: 600;
  font-size: var(--text-base);
}

/* The quiet counterpart: the deal is not going anywhere. Same position on the page, so the
   warning appearing is a change of content rather than a change of layout. */
.steady {
  padding-inline-start: var(--space-3);
  border-inline-start: 2px solid var(--border-strong);
  font-size: var(--text-sm);
  color: var(--text-muted);
  max-inline-size: var(--measure);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.refused {
  display: grid;
  gap: var(--space-4);
  justify-items: start;
}

.note {
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.failure {
  display: grid;
  gap: var(--space-2);
  font-size: var(--text-sm);
  color: var(--danger);
  max-inline-size: var(--measure);
}

.issues {
  display: grid;
  gap: var(--space-1);
  padding-inline-start: var(--space-5);
  list-style: disc;
}
